var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"re-box"},[_c('el-input-number',{attrs:{"size":"small","controls":false,"placeholder":_vm.placeholder},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }